import moment from 'moment';
import {
    consultarPerfil,
    getContrato,
    getFuncoesContrato,
    getSituacaoEmpresa,
    getEstados,
    getEstadoCivil,
    getEmpresas,
    adicionarPerfilRH,
    getReferenciaMovimentacao,
    getInformacoesEmpresa,
} from '../services';
import { checkIsSupport } from './auth';
import { getRedirectUrls } from '../services/gerenciadorPortal/portalEmpresa';

function getSituationLabel(situationInitials) {
    const situationRelation = {
        A: 'Ativo',
        E: 'Encerrado',
        I: 'Suspenso',
        P: 'Em implantação',
    };

    return situationRelation[situationInitials];
}

export async function getFormattedContractLoginData({ contract, email }) {
    const { numeroContrato: contractNumber } = contract;

    const reqContractData = (async () => {
        const [contractInfos] = await getContrato(contractNumber);

        const [parametros] = contractInfos.parametros;

        let vigenciaUltrapassada = false;
        let vigenciaFutura = false;

        if (contractInfos.dataUltimaVigencia) {
            vigenciaUltrapassada = moment() > moment(contractInfos.dataUltimaVigencia, 'DD/MM/YYYY');
            vigenciaFutura = moment() < moment(contractInfos.dataInicioVigencia, 'DD/MM/YYYY');
        }

        // Contratos para regra especifica! Demanda: https://dev.azure.com/TGAeF/GNDI-Novos_Portais/_workitems/edit/718
        // 16096 - Desenvolvimento - Criação do link do legado para Registro de Acidentados - 11003
        const specificsContracts = ['47434600'];

        const businessRulesObject = {
            isHealth: contractInfos.tipoProduto?.codigo === 1,
            isDental: contractInfos.tipoProduto?.codigo === 2,
            isPme: contractInfos.regraEmpresa?.porte === 'PME',
            isPj: contractInfos.regraEmpresa?.porte === 'PJ',
            isMd: contractInfos.regraEmpresa?.porte === 'MD',
            isMaezinha: contractInfos.regraEmpresa?.porte === 'MAEZINHA',
            isAdesao: contractInfos.regraEmpresa?.porte === 'ADESAO',
            isLicitacao: contractInfos.regraEmpresa?.porte === 'LICITACAO',
            isGpa: ['PARTICULAR', 'ATENDIMENTO EVENTUAL'].includes(contractInfos.regraEmpresa.nomeTipo.toUpperCase()),
            isSpecificContract: specificsContracts.includes(contractNumber.toString()),
            specificsContractsList: specificsContracts,
            healthDeclarationRequired: contractInfos.obrigatorioDeclaracaoSaude,
            situationLabel: getSituationLabel(contractInfos.situacao),
            vigenciaUltrapassada,
            vigenciaFutura,
        };

        return {
            ...contractInfos,
            ...businessRulesObject,
            parametros,
        };
    })();

    const reqProfileData = (async () => {
        let [profileInfos] = await consultarPerfil({ email, contrato: contractNumber });

        if (contract.classificacaoContatoRH && !profileInfos) {
            const { data } = await adicionarPerfilRH({
                contrato: contract.numeroContrato,
                email,
            });

            profileInfos = data;
        }

        if (!contract.numeroContratoAtivo) {
            profileInfos = { ...profileInfos, permissoes: [{ id: '4' }] };
        }

        if (checkIsSupport()) {
            profileInfos = { ...profileInfos, permissoes: [{ id: '8' }] };
        }

        if (!profileInfos) {
            profileInfos = {
                permissoes: [],
            };
        }

        profileInfos.permissoesFlat = profileInfos?.permissoes.reduce((acc, cur) => ({ ...acc, [cur.id]: true }), {});

        return profileInfos;
    })();

    const reqReferenciaMovimentacao = getReferenciaMovimentacao(contractNumber);

    const reqFuncoes = getFuncoesContrato(contractNumber) || [];
    const reqEmpresas = getEmpresas(contractNumber) || [];
    const reqInformacoesEmpresa = getInformacoesEmpresa(contractNumber) || {};

    const reqSituacaoEmpresa = getSituacaoEmpresa() || [];
    const reqEstados = getEstados() || [];
    const reqEstadoCivil = getEstadoCivil() || [];
    const reqRedirectUrls = getRedirectUrls(contractNumber) || {};

    sessionStorage.setItem('numeroContratoAtivo', contractNumber);

    const promises = [
        reqContractData,
        reqProfileData,
        reqReferenciaMovimentacao,
        reqFuncoes,
        reqEmpresas,
        reqInformacoesEmpresa,
        reqSituacaoEmpresa,
        reqEstados,
        reqEstadoCivil,
        reqRedirectUrls,
    ];

    const [
        contractData,
        profileData,
        referenciaMovimentacao,
        funcoes,
        empresas,
        informacoesEmpresa,
        situacaoEmpresa,
        estados,
        estadoCivil,
        billingRedirectUrls,
    ] = await Promise.all(promises);

    const validsHealthPlans = contractData.planos.filter(({ dataFimValidade }) => {
        const isFutureDate = moment(dataFimValidade) >= moment();

        return !dataFimValidade || isFutureDate;
    });

    const treatedPlans = validsHealthPlans.map((plan) => ({
        ...plan,
        nome: `${plan.codigo} - ${plan.nome}`,
    }));

    return {
        staticOptions: {
            situacaoEmpresa,
            estados,
            estadoCivil,
        },
        formattedContract: {
            ...contractData,
            planos: treatedPlans,
            planosVinculados: contractData.planos,
            referenciaMovimentacao,
            funcoes,
            empresas,
            informacoesEmpresa,
            billingRedirectUrls,
        },
        profileData,
    };
}
